import { useContext } from 'react'

import { ServiceWorkerContext } from './ServiceWorkerProvider'

const useServiceWorker = () => {
    const context = useContext(ServiceWorkerContext)
    return context
}

export default useServiceWorker